import { useContext, useState } from "react";
import { AppContext } from "../App";
import { MdArrowForward, MdKeyboardArrowDown, MdOutlineShield } from "react-icons/md";
import logo from "../assets/logo.png";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [aboutOpen, setAboutOpen] = useState(false);

  function goTo(item, subItem = null) {
    appContext.navTo({
      item,
      subItem,
    });
  }

  function isActive(item) {
    if (item === "home") {
      return !appContext.navItem || appContext.navItem === "home";
    }

    return appContext.navItem === item;
  }

  function selectAbout(subItem) {
    setAboutOpen(false);

    if (document.activeElement) {
      document.activeElement.blur();
    }

    goTo("about", subItem);
  }

  return (
    <header className="TopBar">
      <div className="container topbar-inner">
        <div className="brand-lockup" onClick={() => goTo("home")}>
          <img src={logo} alt="Runzewe Security" />
          <div>
            <strong>Runzewe Security</strong>
            <span>Tanzania</span>
          </div>
        </div>

        <nav className="DesktopMenu">
          <button
            className="topbar-link"
            data-active={isActive("home")}
            onClick={() => goTo("home")}
          >
            Home
          </button>

          <div
            className="topbar-dropdown"
            onMouseEnter={() => setAboutOpen(true)}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <button
              className="topbar-link"
              data-active={isActive("about")}
              onClick={() => setAboutOpen((current) => !current)}
            >
              About
              <MdKeyboardArrowDown />
            </button>

            <div className="topbar-dropdown-menu" data-open={aboutOpen}>
              <button onClick={() => selectAbout("overview")}>Overview</button>
              <button onClick={() => selectAbout("team")}>Team</button>
            </div>
          </div>

          <button
            className="topbar-link"
            data-active={isActive("services")}
            onClick={() => goTo("services")}
          >
            Services
          </button>

          <button
            className="topbar-link"
            data-active={isActive("clients")}
            onClick={() => goTo("clients")}
          >
            Clients
          </button>

          <button
            className="topbar-link"
            data-active={isActive("contact")}
            onClick={() => goTo("contact")}
          >
            Contact
          </button>
        </nav>

        <button className="topbar-quote mDesktopOnly" onClick={() => goTo("contact")}>
          <MdOutlineShield />
          <span>Get A Quote</span>
          <MdArrowForward className="quote-arrow" />
        </button>
      </div>
    </header>
  );
}
